var AjaxPostsModule = function () {

    var self = this;

    /**
     * @var array
     */
    self.container = jQuery('.ajax-load-posts');
    if (self.container.length === 0) {
        return;
    }

    self.type = self.container.data('post-type');
    self.posts_per_page = self.container.data('posts-per-page');
    self.page = 1;
    self.filterCategory = false;
    self.filterValue = false;
    self.meta_field = self.container.data('meta-field');
    self.meta_value = self.container.data('meta-value');
    self.meta_type = self.container.data('meta-type');
    self.loadingContainer = jQuery('.loading-posts');

    self.loaded = function() {
        self.loadingContainer.removeClass('loading');
    }

    self.filterPosts = function(event) {
        var 
            $this = jQuery(event.target)
        ;

        self.filterCategory = $this.data('category');
        self.filterValue = $this.val();

        self.loadPosts();
    };

    self.paginatePosts = function (event) {
        
        event.preventDefault();

        var 
            url = event.target.href
        ;
        
        if (typeof url == 'undefined') {
            return;
        }

        
        self.page = url.split('?paged=').pop();
        self.loadPosts();

        EventBus.publish('scroll-to-target', {target: self.container});


    }

    self.loadPosts = function () {
        
        var action = 'load-posts',
            data = {}

        if (self.filterCategory) {
            data.filterCategory = self.filterCategory;
        }

        if (self.filterValue) {
            data.filterValue = self.filterValue;
        }

        if (self.meta_field) {
            data.meta_field = self.meta_field;
        }

        if (self.meta_value) {
            data.meta_value = self.meta_value;
        }

        if (self.meta_type) {
            data.meta_type = self.meta_type;
        }

        if (self.posts_per_page) {
            data.posts_per_page = self.posts_per_page
        }

        data.post_type = self.type;
        data.action = action;
        data.page = self.page;

        jQuery.post(ajaxUrl, data, function(response, status, xhr) {
            self.loaded();
            self.container.empty().append(response.data.html);
        });
    };

    /**
     * Bind events
     */
    self.bindEvents = function () {
        EventBus.subscribe('run-modules', self.loadPosts);
        jQuery(document).on('change', '.ajax-filter-posts', self.filterPosts);
        jQuery(document).on('click', '.page-link', self.paginatePosts);
    };

    self.bindEvents();

};

EventBus.subscribe('init-modules', function () {
    new AjaxPostsModule();
})